<template>
  <v-btn
    v-if="action_for == 'user_imports'"
    :disabled="disableBulkUserUpload"
    color="blue darken-1"
    text
    @click="saveDialog()"
  >
    Save
  </v-btn>
</template>
<script>
import {mapState} from "vuex"
import swal from 'sweetalert2'
export default {
  props: {
    action_for: String,
    errorMessage: String,
    disableSave: Boolean,
  },
  methods: {
    saveDialog() {
      //@TODO: PASS DATA TO BE  PARAMERS CAN BE FOUND IN `user_details`
      if (this.action_for == "user_imports")
        this.$store.dispatch('file_imports/create_users',this.user_details)
        .then((response)=>{
          console.log(response)
          swal
          .fire(
            "Completed!",
            `Created ${response.data.length} new users`,
            "success"
          )
          .then(() => {
            location.reload();
          })
        })
        .catch(()=>{
          swal
          .fire(
            "Something went wrong!",
            `Please contact Administrator`,
            "success"
          )
        })
    }
  },
  computed: {
    ...mapState({
      user_details: (state) => state.file_imports.users,
    }),
    disableBulkUserUpload() {
      let ud = this.user_details;
      if(this.disableSave)
        return true
      else{
        
      if(this.errorMessage !== "")
        return true;
      if (ud.data.length > 0 && ud.default_password != "" && ud.office != "")
        return false;
      else return true;
      }
    }, 
  }
};
</script>
